import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../../../apollo-client';
import {appHistory} from '../../../history';
import {store} from '../../../store';

import {UsersBanner} from './banners/users-banner';

const USERS_BANNER_REACT_MOUNT_ID = 'users-banner-react-mount';

export function mountUsersBanner() {
    const mount = document.getElementById(USERS_BANNER_REACT_MOUNT_ID);
    const maxUsers = mount && mount.dataset.maxusers;
    const enabledUsers = mount && mount.dataset.enabledusers;

    if (mount && maxUsers && enabledUsers) {
        ReactDOM.render(
            <Provider store={store}>
                <ApolloProvider client={nutApolloClient}>
                    <ReactHooksApolloProvider client={nutApolloClient}>
                        <Router history={appHistory}>
                            <UsersBanner maxUsers={maxUsers} enabledUsers={enabledUsers} />
                        </Router>
                    </ReactHooksApolloProvider>
                </ApolloProvider>
            </Provider>,
            mount
        );
    }
}
